import React from "react";
import type firebase from "firebase/app";
import BorderLoader from "../atoms/loader/BorderLoader";

import { Paw } from "../../styles";

type PawBalanceProps = {
  pawValue: number;
  user: firebase.User;
  isLoading: boolean;
};

export const PawBalance = (props: PawBalanceProps) => {
  const { pawValue, user, isLoading } = props;
  if (user.emailVerified === false) {
    //フラスタの画面を表示する際にログインの認証があるため基本は表示されない
    // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
    return <>email未認証</>;
  }
  if (isLoading) {
    return <BorderLoader />;
  }
  return <Paw>{pawValue.toLocaleString()}</Paw>;
};
